import type { EmprestimoStatus } from "@/shared/types/database.types";

/**
 * Cores dos badges de status de empréstimo.
 * Centralizado aqui para evitar duplicação entre GerenciarEmprestimos e
 * DashboardUsuario, que antes definiam o mesmo objeto separadamente.
 */
export const CORES_STATUS: Record<EmprestimoStatus, string> = {
  PENDENTE: "bg-warning/10 text-warning",
  EM_ABERTO: "bg-info/10 text-info",
  DEVOLVIDO: "bg-success/10 text-success",
  ATRASADO: "bg-danger/10 text-danger",
  REJEITADO: "bg-surface-2 text-muted",
};

/**
 * Formata uma string de data ISO (YYYY-MM-DD) para exibição no formato
 * brasileiro (DD/MM/AAAA). Centralizado aqui para eliminar duplicação.
 */
export function formatarData(data: string | null): string {
  if (!data) return "—";
  return new Date(data + "T00:00:00").toLocaleDateString("pt-BR");
}
